"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToUpgrade() {
  return <section data-section-id="223313" id="ready-to-upgrade" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-48 flex items-center justify-center">
      {}
      <style>
        {`
          @keyframes float-rotate {
            0%, 100% { transform: translateY(0) rotate(-5deg); }
            50% { transform: translateY(-20px) rotate(5deg); }
          }
          .animate-float-rotate {
            animation: float-rotate 12s ease-in-out infinite;
          }
        `}
      </style>

      {}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_60%)] opacity-15 pointer-events-none" />

      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686383/img/clifrock_outdoor_kitchen_render.png" alt="ClifRock Masonry System" className="animate-float-rotate max-w-[120%] md:max-w-4xl w-full object-contain opacity-20 blur-[2px] scale-110" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center">
        <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold mb-6 tracking-tight text-balance text-foreground">
          Ready to Upgrade?
        </h2>
        
        <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl mb-12 text-balance">
          Join the network of elite contractors building high-end outdoor living spaces in half the time. Get the technical guide to our panel masonry system today.
        </p>
        
        <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-md px-8 h-14 text-lg group shadow-lg">
          <Link to="/InstallerOpportunityPage">
            Get the Technical Guide
            <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      </div>
    </section>;
}